'use strict';

// Detect cancelled dialog HACK
// implemented based on StackOverflow discussion
// http://stackoverflow.com/questions/22898854/find-if-cancel-was-clicked-on-file-input

export class FileDialog {
  constructor() {
    Object.defineProperty(this, '$$deferred', {value: Promise.defer()});
    Object.defineProperty(this, '$$input', {configurable: true, value: document.createElement('input')});
    this.$$input.setAttribute('type', 'file');

    this.$$input.addEventListener("change", this.__onChange.bind(this), false);
  }

  open(multiple) {
    //console.log('FileDialog.open', multiple);
    if (multiple) {
      this.$$input.setAttribute('multiple', 'multiple');
      this.$$input.value = '';
      //console.dir(this.$$input)
    }
    // part of the detect cancelled dialog hack
    document.body.onfocus = () => setTimeout(this.__checkOnCancel.bind(this), 250);

    this.$$input.click();
    return this.$$deferred.promise;
  }

  dispose() {
    if (this.$$input) {
      this.$$input.remove();
      delete this.$$input;
    }
  }

  __onChange(change) {
    //console.dir(this.$$input)
    if (change.path && change.path[0] && change.path[0].files) {
      // Handle Chrome
      //console.log('FileDialog Chrome');
      this.$$deferred.resolve(change.path[0].files);
    } else if (this.$$input.files) {
      // Handle Firefox
      //console.log('FileDialog Firefox');
      this.$$deferred.resolve(this.$$input.files);
    } else {
      console.warn('FileDialog else case');
    }
  }

  // part of the detect cancelled dialog hack
  __checkOnCancel() {
    if (this.$$input.value.length === 0) {
      // cancelled
      //console.log('FileDialog cancelled');
      this.$$deferred.resolve(null);
    }
    document.body.onfocus = null;
  }
}

FileDialogService.$inject = [];

export function FileDialogService() {

  return FileDialog
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/file-dialog/FileDialog.js